import {
  CentralModal,
  ConfirmActionDialog
} from '@eggplant/pattern-library'
import { useState } from 'react'
import type { CSSProperties } from 'react'

type Resolve = undefined | ((value: unknown) => void)

// eslint-disable-next-line fp/no-let
let resolver: Resolve

const createPromise = () => {
  // eslint-disable-next-line fp/no-let
  let rejecter

  const promise = new Promise((resolve, reject) => {
    // eslint-disable-next-line fp/no-mutation
    resolver = resolve
    // eslint-disable-next-line fp/no-mutation
    rejecter = reject
  })

  return [promise, resolver, rejecter]
}

const modalWrapperStyle: CSSProperties = {
  height: '100%' // for success message vertical centering
}

const useConfirm = (
  onReset: () => void,
  actionText?: string,
  cancelText?: string,
  title?: string
) => {
  const [label, setLabel] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLeaveWithSave, setIsLeaveWithSave] = useState<boolean|undefined>(undefined)

  const getConfirmation = async (text: string) => {
    setLabel(text)
    setIsModalOpen(true)

    const [promise] = await createPromise()

    return promise
  }

  const handleModalClose = () => {
    setIsLeaveWithSave(undefined)
    setIsModalOpen(false)
    onReset()
  }

  const handleLeaveWithSaveConfirm = () => {
    setIsLeaveWithSave(true)
    setIsModalOpen(false)
    void Promise.resolve('true')
  }

  const handleLeaveWithoutSaveCancel = () => {
    setIsLeaveWithSave(false)
    setIsModalOpen(false)
    void Promise.resolve('false')
  }

  const Confirmation = () => (
    <CentralModal
      isOpen={isModalOpen}
      label='Unsaved changes and leave page'
      onRequestClose={handleModalClose}
    >
      <div style={modalWrapperStyle}>
        <ConfirmActionDialog
          actionText={actionText || 'Save and continue'}
          cancelText={cancelText || 'Discard and continue'}
          message={label} // {'You\'re about to leave this page with unsaved changes. Save before continuing?'}
          onCancel={handleLeaveWithoutSaveCancel}
          onConfirm={handleLeaveWithSaveConfirm}
          title={title || 'Unsaved changes'}
          variant='primary'
        />
      </div>
    </CentralModal>
  )

  return {
    getConfirmation,
    isLeaveWithSave,
    Confirmation
  }
}

export default useConfirm
